
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPlatformHealth"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPlatformHealth"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gmvMonth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"workerRevenueMonth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"platformRevenueMonth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gmvAllTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"workerRevenueAllTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"providersOnline"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"providersOffline"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalProviders"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalCustomers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bookingsToday"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bookingsMonth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"completedMonth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cancelledMonth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cancelRate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"newCustomers30d"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"newProviders30d"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"openDisputes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"openTickets"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pendingRefunds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"daily"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bookings"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"revenue"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":514}};
    doc.loc.source = {"body":"query getPlatformHealth {\n  getPlatformHealth {\n    currency\n    gmvMonth\n    workerRevenueMonth\n    platformRevenueMonth\n    gmvAllTime\n    workerRevenueAllTime\n    providersOnline\n    providersOffline\n    totalProviders\n    totalCustomers\n    bookingsToday\n    bookingsMonth\n    completedMonth\n    cancelledMonth\n    cancelRate\n    newCustomers30d\n    newProviders30d\n    openDisputes\n    openTickets\n    pendingRefunds\n    daily {\n      date\n      bookings\n      revenue\n    }\n    status\n    errorMessage\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["getPlatformHealth"] = oneQuery(doc, "getPlatformHealth");
        
